import { useGetProjectTemplatesQuery } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { useGetWorkspacesInfo } from '../../shared/hooks';

export const useProjectTemplates = () => {
  const accountId = useActiveAccountId();
  const workspaces = useGetWorkspacesInfo({
    accountId: accountId ?? '',
  })?.data?.account?.workspaces?.nodes;

  const templatesWorkspaceId = workspaces?.[0]?.id;

  const templates = useGetProjectTemplatesQuery({
    skip: !templatesWorkspaceId,
    variables: { workspaceId: templatesWorkspaceId ?? '' },
  })?.data?.account?.workspace?.projectTemplates?.nodes;

  return templates;
};
